import React from 'react';
import { TASK, ENV, uniqCount, thumbSrc } from '../../lib/gallery';

const slug = (s) => s.replace(/[^a-z0-9]+/gi, '-').toLowerCase();

const GalleryCard = ({ r, onOpen }) => (
  <button
    type="button"
    onClick={onOpen}
    className="group text-left bg-[#141414] border border-white/10 rounded-xl overflow-hidden cursor-zoom-in hover:border-[#FF7A00]/40 transition-colors duration-200"
    data-testid={`gallery-card-${r.id}`}
  >
    <div className="aspect-video bg-white/[0.04] overflow-hidden">
      <img loading="lazy" decoding="async" src={thumbSrc(r)} alt={r.caption} className="w-full h-full object-cover group-hover:scale-[1.04] transition-transform duration-500" />
    </div>
    <div className="px-3 py-2.5 grid gap-0.5 min-w-0">
      <b className="text-[13px] font-semibold text-white truncate">{TASK(r)}</b>
      <span className="text-xs text-white/40 truncate">{ENV(r)} · {r.action}</span>
      <span className="text-xs text-white/30 truncate">{r._objs.slice(0, 5).join(", ")}</span>
    </div>
  </button>
);

export const GallerySection = ({ category, rows, indexOf, onOpen }) => (
  <section className="mb-10 [content-visibility:auto] [contain-intrinsic-size:auto_600px]" data-testid={`gallery-section-${slug(category)}`}>
    <h3 className="text-lg font-bold mb-0.5">{category}</h3>
    <p className="text-[13px] text-white/40 mb-3">
      {uniqCount(rows, (r) => [ENV(r)])} environments · {uniqCount(rows, (r) => [TASK(r)])} tasks · {uniqCount(rows, (r) => r._objs)} objects &amp; tools
    </p>
    <div className="grid gap-2.5 grid-cols-[repeat(auto-fill,minmax(230px,1fr))]">
      {rows.map((r) => <GalleryCard key={r.id} r={r} onOpen={() => onOpen(indexOf.get(r.id))} />)}
    </div>
  </section>
);
